"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const Dictionary_1 = require("./dictionaries/Dictionary");
class DictionariesService {
    constructor(dictionaryDataApiService, dictionaryMetadataApiService, dictionariesCacheService) {
        this._dictionaryDataApiService = dictionaryDataApiService;
        this._dictionaryMetadataApiService = dictionaryMetadataApiService;
        this._cacheService = dictionariesCacheService;
        this._cachedDictionaries = new Map();
    }
    getDefinition(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const map = yield this.getDefinitions([id]);
            const result = map.get(id);
            return result;
        });
    }
    getDefinitions(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const cacheService = this._cacheService;
            const cachedDefs = ids.reduce((acc, id) => {
                const def = cacheService.getDefinition(id);
                if (def !== undefined) {
                    acc.push(def);
                }
                return acc;
            }, []);
            // get non-cached entities
            const idsForLoad = ids.filter((id) => cachedDefs.find((x) => x.id == id) === undefined);
            // load new entities if necessary
            const loadedDefs = idsForLoad.length > 0 ? yield this._dictionaryMetadataApiService.get(ids) : [];
            // add new loaded entities to cache
            loadedDefs.forEach((def) => cacheService.setDefinition(def));
            const result = new Map(loadedDefs.concat(cachedDefs).map((x) => [x.id, x]));
            // validate result
            for (const id of ids) {
                if (!result.has(id)) {
                    throw new Error(`Dictionary ${id} does not exist`);
                }
            }
            return result;
        });
    }
    getDictionary(resolveOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const resolveOptionsKey = JSON.stringify(resolveOptions);
            let dictionary = this._cachedDictionaries.get(resolveOptionsKey);
            if (!dictionary) {
                const { id, parameters } = resolveOptions;
                const definition = yield this.getDefinition(id);
                dictionary = new Dictionary_1.Dictionary(this._dictionaryDataApiService, this._cacheService, definition, parameters);
                this._cachedDictionaries.set(resolveOptionsKey, dictionary);
            }
            return dictionary;
        });
    }
    getDictionaries(resolveOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const ids = resolveOptions.map((x) => x.id);
            const definitions = yield this.getDefinitions(ids);
            const instances = resolveOptions.map((info) => {
                const resolveOptionsInfoKey = JSON.stringify(info);
                let dictionary = this._cachedDictionaries.get(resolveOptionsInfoKey);
                if (!dictionary) {
                    const { id, parameters } = info;
                    const def = definitions.get(id);
                    Dictionary_1.Dictionary.validateParameters(def, parameters);
                    dictionary = new Dictionary_1.Dictionary(this._dictionaryDataApiService, this._cacheService, def, parameters);
                    this._cachedDictionaries.set(resolveOptionsInfoKey, dictionary);
                }
                return dictionary;
            });
            const instancesMap = new Map(instances.map((x) => [x.id, x]));
            return instancesMap;
        });
    }
}
exports.DictionariesService = DictionariesService;
//# sourceMappingURL=DictionariesService.js.map